import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_PASSBOOK} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const Passbook = lazy(() =>
  import('../../../screens/Passbook')
    .then(module => ({default: module.Passbook})));

const PassbookNavigation = [
  {
    path: ROUTE_PASSBOOK,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <Passbook />
      </Suspense>
    ),
  },
];

export default PassbookNavigation;
